<template>
  <div v-if="model">
    <div class="row">
      <div class="col-12">
        <div class="container-title">
          {{ $t('sale_notes.shows.sales_invoice') }}
        </div>
        <b-card no-body>
          <b-card-body>
            <div class="row">
              <div class="col-xs-12 col col-xl-8">
                <span style="position: absolute;top: 0; right: 16px">
                  <i v-if="updateStatus === 'updated'" class="bx bxs-check-circle bx-fw" style="color: #379E2F"/>
                  <box-icon v-else-if="updateStatus === 'updating'" name="refresh" animation="spin" class="bx-fw" color="#1B77DF"></box-icon>
                  <i v-else class="bx bxs-x-circle bx-fw" style="color: #F14250"/>
                  {{ updateStatusMessage }}
                </span>
                <div class="row">
                  <div class="col-xs-12 col-md-4">
                    <b-card-text class="custom-group">
                      <div class="custom-label">{{ lodash.startCase($t('sale_notes.invoices.invoice_number')) }}</div>
                      <span class="custom-text">{{ invoiceNumber  }}</span>
                    </b-card-text>
                  </div>
                  <div class="col-xs-12 col-md-8">
                    <b-card-text class="custom-group">
                      <div class="custom-label">{{ lodash.startCase($t('sale_notes.invoices.destination')) }}</div>
                      <span class="custom-text">{{ destination  }}</span>
                    </b-card-text>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-4">
                    <b-card-text class="custom-group">
                      <div class="custom-label">{{ lodash.startCase($t('products.singular')) }}</div>
                      <span class="custom-text">{{ serviceNames.join(',')  }}</span>
                    </b-card-text>
                  </div>
                  <div class="col-xs-12 col-md-8">
                    <b-card-text class="custom-group">
                      <div class="custom-label">{{ lodash.startCase($t('sale_notes.invoices.address')) }}</div>
                      <span class="custom-text" v-html="destinationAddress"/>
                    </b-card-text>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-4">
                    <b-card-text class="custom-group">
                      <div class="custom-label">{{ lodash.startCase($t('sale_notes.invoices.margin_per_kg')) }}</div>
                      <span class="custom-text">{{ serviceFees.map(fee => $numeral(fee).format('$ 0,0.[00]')).join(',')  }}</span>
                    </b-card-text>
                  </div>
                  <div class="col-xs-12 col-md-8">
                    <div class="row">
                      <div class="col-sm-6">
                        <b-card-text class="custom-group">
                          <div class="custom-label">{{ lodash.startCase($t('sale_notes.invoices.send_at')) }}</div>
                          <span class="custom-text">{{
                              deliveredAt ? $moment.utc(deliveredAt).local().format('DD MMM YYYY') : '-'
                            }}</span>
                        </b-card-text>
                      </div>
                      <div class="col-sm-6">
                        <b-card-text class="custom-group">
                          <div class="custom-label" style="font-weight: 400; color: #6C7589">{{
                              `${lodash.startCase($t('sale_notes.invoices.send_at'))} (${lodash.startCase($t('sale_notes.partner'))})`
                            }}
                          </div>
                          <span v-if="isPaidOff" class="custom-text">{{
                              form.partner_tripped_date ? $moment.utc(form.partner_tripped_date).local().format('DD MMM YYYY') : '-'
                            }}</span>
                          <date-picker
                              v-else
                              class="custom-datepicker"
                              v-model="form.partner_tripped_date"
                              name="ordered_at"
                              format="DD MMMM YYYY"
                              type="date"
                              required
                          />
                        </b-card-text>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-4">
                    <b-card-text class="custom-group">
                      <div class="custom-label">{{ lodash.startCase($t('sale_notes.invoices.license_plate'))}}</div>
                      <span v-if="licensePlate || isPaidOff" class="custom-text">{{ licensePlate || '-' }}</span>
                      <template v-else>
                        <b-form-group
                        >
                          <b-input-group>
                            <b-form-input
                                v-model="form.license_plate"
                                class="custom-input"
                                id="license_plate"
                                type="text"
                                name="license_plate"
                                :placeholder="lodash.startCase($t('sale_notes.invoices.license_plate'))"
                            />
                          </b-input-group>
                        </b-form-group>
                      </template>
                    </b-card-text>
                  </div>
                  <div class="col-xs-12 col-md-8">
                    <div class="row">
                      <div class="col-sm-6">
                        <b-card-text class="custom-group">
                          <div class="custom-label">{{ lodash.startCase($t('sale_notes.invoices.due_at')) }}</div>
                          <date-picker
                              v-model="form.due_date"
                              class="custom-datepicker"
                              format="DD MMMM YYYY"
                              name="ordered_at"
                              required
                              type="date"
                              :disabled="!$auth.hasPermissionTo('sale_reports.edit')"
                          />
                        </b-card-text>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-8">
                    <b-card-text class="custom-group">
                      <div class="custom-label">{{ lodash.startCase($t('sale_notes.invoices.note')) }}</div>
                      <b-form-group>
                        <b-input-group>
                          <span v-if="isPaidOff" class="custom-text">{{ form.description || '-'  }}</span>
                          <b-form-textarea
                              v-else
                              id="note"
                              type="text"
                              name="note"
                              v-model="form.description"
                              :placeholder="lodash.startCase($t('sale_notes.invoices.note_content'))"
                              style="height: 124px"
                              :disabled="isPaidOff"
                          />
                        </b-input-group>
                      </b-form-group>
                    </b-card-text>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-xl-4">
                <b-card no-body class=" mb-3 shadow-none">
                  <b-table-simple class="sales-invoice-item" responsive style="margin: 0; border-radius: 8px">
                    <b-thead>
                      <b-tr>
                        <b-th colspan="2">
                          Total
                        </b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr>
                        <b-td>Sub total</b-td>
                        <b-td style="text-align: right">{{ currencyFormatter(subtotal) }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td>Diskon</b-td>
                        <b-td style="text-align: right">{{ currencyFormatter(totalDiscount) }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td>Biaya</b-td>
                        <b-td style="text-align: right">{{ currencyFormatter(totalAdditionalFee) }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td>Terbayar</b-td>
                        <b-td style="text-align: right">{{ currencyFormatter(totalPaid) }}</b-td>
                      </b-tr>
                    </b-tbody>
                    <b-tfoot>
                      <b-tr>
                        <b-td style="color: #1E1E1F">Total tagihan</b-td>
                        <b-td style="color: #1DA62B; font-weight: 700;text-align: right">{{ currencyFormatter(remainingReceivable ) }}</b-td>
                      </b-tr>
                    </b-tfoot>
                  </b-table-simple>
                </b-card>
                <div
                  v-if="$auth.hasPermissionTo('sale_reports.export')"
                >
                  <b-button class="btn btn-success btn-download me-2 mb-2" :disabled="loadingExportInternal" @click="handleExport(1)">
                    <i :class="{
                      'bx bxs-download': !loadingExportInternal,
                      'bx bx-loader spin':loadingExportInternal,
                      'me-2': true,
                      }"
                    ></i>Invoice Internal</b-button>
                  <b-button class="btn btn-outline-dark btn-download mb-2" :disabled="loadingExportPartner" @click="handleExport(0)">
                    <i :class="{
                      'bx bxs-download': !loadingExportPartner,
                      'bx bx-loader spin':loadingExportPartner,
                      'me-2': true,
                      }"
                    ></i>Invoice Mitra</b-button>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <div class="col-12">
        <div class="container-title">
          {{ $t('sale_notes.invoices.goods_list') }}
        </div>
        <b-card no-body style="margin-bottom: 0">
          <b-table-simple class="sales-invoice-item" responsive hover style="margin: 0; border-radius: 8px">
            <b-thead>
              <b-tr>
                <b-th>{{ lodash.startCase($t('sale_notes.invoices.goods_lists.harvested_at')) }}</b-th>
                <b-th>{{ lodash.startCase($t('sale_notes.invoices.goods_lists.farmer')) }}</b-th>
                <b-th>{{ lodash.startCase($t('sale_notes.invoices.goods_lists.goods_name')) }}</b-th>
                <b-th>{{ lodash.startCase($t('sale_notes.invoices.goods_lists.biomass')) }}</b-th>
                <b-th style="text-align: right">{{ lodash.startCase($t('sale_notes.invoices.goods_lists.price')) }}</b-th>
                <b-th  style="text-align: right">{{ lodash.startCase($t('sale_notes.invoices.goods_lists.total')) }}</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="({
              harvested_at,
              farmer_name,
              goods_name,
              quantity,
              unit_price,
              total_price,
              }, index) in tableItems" v-bind:key="index">
                <b-td>{{ harvested_at ? $moment.utc(harvested_at).local().format('DD-MM-YYYY') : '-' }}</b-td>
                <b-td>{{ farmer_name }}</b-td>
                <b-td>{{ goods_name }}</b-td>
                <b-td>{{ decimalFormatter(quantity) }}</b-td>
                <b-td  style="text-align: right">{{ currencyFormatter(unit_price) }}</b-td>
                <b-td  style="text-align: right">{{ currencyFormatter(total_price) }}</b-td>
              </b-tr>
            </b-tbody>
            <b-tfoot>
              <b-tr>
                <b-th colspan="3"></b-th>
                <b-th>{{ decimalFormatter(totalBiomass) }}</b-th>
                <b-th colspan="2" style="text-align: right">{{ currencyFormatter(totalPrice) }}</b-th>
              </b-tr>
            </b-tfoot>
          </b-table-simple>
        </b-card>
      </div>
      <div class="col-12" style="margin: 8px 0">
        <span>{{ lodash.startCase($t('CreatedBy')) }}: {{ creatorName }} - {{ $moment.utc(model.created_at).local().format('DD MMM YYYY hh:mm:ss') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash"
import DatePicker from "@/components/inputs/datepicker";
import ModelShow from '../../models/show';
import Row from '@/components/models/show/custom-row';
import Swal from 'sweetalert2'

export default {
  extends: ModelShow,
  page: {
    title: "Detail Sale Notes",
  },
  components: {
    DatePicker,
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('sale_notes.singular')) }},
    resourceRoute: {default: 'sale_notes'},
    modelVariable: {default: 'sale_note'},
    denyDelete: {type: Boolean, default: true},
    denyEdit: {type: Boolean, default() {return !this.$auth.hasJalaTradeRole(['admin', 'finances'])}},
    columns: {
      type: Object,
      default() {
        return {
          [this.  modelVariable || 'model']: [
            {
              key: 'key',
              label: this.$t('models.key'),
              component: Row
            }
          ]
        };
      }
    },
    cardAttrs: {
      default() {
        return {
          class: 'card-plain',
          style: {marginBottom: 0, padding: 0, overflow: 'hidden'},
          noBody: true,
          'data-simplebar': true,
          'data-simplebar-auto-hide': "false"
        }
      }
    },
    value: { type: Object, default: function () {return {}} },
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('sale_notes.plural')),
      salesInvoice: this.value.sales_invoice,
      form: this.lodash.cloneDeep({
        id: this.value.sales_invoice?.id,
        license_plate: this.value.sales_invoice?.license_plate,
        due_date: this.value.sales_invoice?.due_date,
        partner_tripped_date: this.value.sales_invoice?.partner_tripped_date,
        description: this.value.sales_invoice?.description,
      }),
      loadingUpdate: false,
      loadingExportInternal: false,
      loadingExportPartner: false,
      updateStatus: 'updated',
    }
  },
  computed: {
    isPaidOff() {
      return this.value.remaining_receivable <= 0;
    },
    updateStatusMessage() {
      if (this.updateStatus === 'updated') return `${this.lodash.upperFirst(this.$t('updated_at'))} ${this.$moment.utc(this.salesInvoice?.updated_at).local().format('DD MMMM YYYY hh:mm')}`
      if (this.updateStatus === 'updating') return  this.lodash.upperFirst(this.$t('updating'))
      return this.lodash.upperFirst(this.$t('failed_to_update'))
    },
    destination(){
      return this.value .sales_invoice?.customer_name
    },
    destinationAddress() {
      let { region_full_name, street } = this.value.sales_invoice?.customer_address ?? {}
      let addresses = []
      if (region_full_name) addresses.push(this.lodash.startCase(region_full_name.toLowerCase()))
      if (street) addresses.push(street)
      return addresses.join(', ')
    },
    deliveredAt() {
      return this.value.sales_invoice?.tripped_date
    },
    dueAt() {
      return this.value.sales_invoice?.due_date
    },
    licensePlate() {
      let { license_plate } = this.value.trip?.vehicle ?? {}
      return license_plate
    },
    purchaseOrders() {
      return this.lodash.uniqBy(this.value?.sale_items.flatMap(({trip_items}) => trip_items.flatMap(({purchase_order}) => purchase_order)), 'id')
    },
    services() {
      return this.lodash.uniqBy(this.purchaseOrders.map(({product}) => product), 'id')
    },
    serviceNames() {
      return this.services.map(({name}) => name).sort((a,b) => a.localeCompare(b))
    },
    serviceFees() {
      return [...new Set(this.services.map(({service_fee}) => service_fee).sort())]
    },
    subtotal() {
      return this.value.sale_item_total
    },
    tableItems() {
      return this.value.sale_items.map(({
          quality,
          quantity,
          size,
          unit_price,
          total_price,
          trip_items
      }) => {
        let purchaseOrders = this.lodash.uniqBy(trip_items.flatMap(({purchase_order}) => purchase_order), 'id')
        let farmer = this.lodash.uniqBy(purchaseOrders.flatMap(({farmer}) => farmer), 'id')[0]
        let harvested_at = purchaseOrders[0]?.ordered_at

        return {
          harvested_at,
          farmer_name: farmer?.name ?? '-',
          goods_name: `Vannamei/${this.qualityFormatter(quality)}/${size}`,
          quantity,
          unit_price,
          total_price
        }
      })
    },
    invoiceNumber() {
      return this.value.sales_invoice?.invoice_number ?? '-'
    },
    totalAdditionalFee() {
      return this.value.sale_additional_items.filter(({ total }) => total > 0).reduce((carry, { total }) => carry + total, 0)
    },
    remainingReceivable() {
      return this.value.remaining_receivable
    },
    totalPrice() {
      return this.value.sale_item_total
    },
    totalBiomass() {
      return this.value.sale_item_total_quantity
    },
    totalDiscount() {
      return -this.value.sale_additional_items.filter(({ total }) => total < 0).reduce((carry, { total }) => carry + total, 0)
    },
    totalPaid() {
      return this.value.sale_payment_total
    },
    creatorName() {
      return this.value?.creator?.name ?? '-'
    },
    items() {
      return [
        {
          text: this.lodash.startCase(this.$t('sale_notes.plural')),
          href: "/sale_notes",
        },
        {
          text: this.value && this.value.id ? this.value['name'] : this.$route.params.key,
          href: `/sale_notes/${this.$route.params.key}`,
          active: true,
        }
      ]
    },
  },
  watch: {
    form: {
      deep: true,
      handler: function (val) {
        this.updateSalesInvoice(val)
      }
    },
    salesInvoice: function (val) {
      this.$emit('input', this.lodash.cloneDeep({...this.value, sales_invoice: val}))
    },
  },
  methods: {
    currencyFormatter(value) {
      return this.$numeral(value).format('$ 0,0.[00]')
    },
    decimalFormatter(value) {
      return this.$numeral(value).format('0,0.[00]')
    },
    qualityFormatter(quality) {
      return ['fresh', 'merah'].includes(quality) ? this.lodash.upperFirst(quality) : this.lodash.upperCase(quality)
    },
    pills(){
      return [
        {
          label: 'Detail',
          active: (this.$route.name === 'sale_notes.show'),
          onClick: () => this.$router.push({ name: 'sale_notes.show', params: { key: this.$route.params.key } })
        },
        {
          label: 'Resume',
          active: (this.$route.name === 'sale_notes.resume'),
          onClick: () => this.$router.push({ name: 'sale_notes.resume', params: { key: this.$route.params.key } })
        },
      ]
    },
    updateSalesInvoice: _.debounce(function (payload) {
      this.loadingUpdate = true
      this.updateStatus = 'updating'
      return this.$axios.put(`/sale_orders/${this.value.id}/sales_invoices/${this.value.sales_invoice.id}`, {...payload}).then(res => {
        let {data: {data}} = res
        this.$set(this, 'salesInvoice', data)
        this.updateStatus = 'updated'
      }).catch(() => this.updateStatus = 'failed').finally(() => this.loadingUpdate = false)
    }, 2000),
    onClickExportButton(isInternal = false) {
      this.handleExport(isInternal)
    },
    handleExport(isInternal = 0) {
      if (isInternal) this.loadingExportInternal = 1
      else this.loadingExportPartner = 1

      return this.$axios.get(`sale_orders/${this.value.id}/sales_invoice_export/${this.salesInvoice.id}`, {
        responseType: 'blob',
        params: {
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          is_internal: isInternal,
        },
      })
      .then(res => {
        // create file link in browser's memory
        const href = URL.createObjectURL(res.data);

        // create "a" HTML element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', `Sales Invoice ${this.salesInvoice.customer_name} ${this.salesInvoice.invoice_number}.pdf`); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
        return res
      }).catch(() => {
        return Swal.fire({
          title: this.lodash.startCase(this.$t('failed')),
          text: this.lodash.upperFirst(this.$t('download_failed')),
          type: 'danger',
          confirmButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        })
      }).finally((res) => {
        if (isInternal) this.loadingExportInternal = false
        else this.loadingExportPartner = false
        return res
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .preloader-component {
    background-color: #FFFFFF;
  }
  .custom-datepicker {
    input {
      //styleName: text-md;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0em;

      background-color: #F4F7FA;
      border: 1px solid #DBDCE2;
      height: 32px !important;
      padding: 6px 8px;
    }
  }
  .custom-input {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;

    background-color: #F4F7FA;
    border: 1px solid #DBDCE2;
    height: 32px !important;
    padding: 6px 8px;
  }
}
button.btn-download {
  display: inline-flex;
  align-items: flex-end;
  border-radius: 5px;
  padding: 7px 16px;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0em;
  &.btn-success {
    color: white !important;
  }
  &.btn-outline-dark {
    color: #363637 !important;
    background-color: white;
    border: 1px solid #363637;
    &:hover {
      background-color: #363637 !important;
      color: white !important;
    }
  }
}
.container-title {
  margin-top: 10px;
  font-family: Lato;
  font-size: 12px;
  font-weight: 800;
  line-height: 14px;
  letter-spacing: 0.05em;
  text-align: left;
  margin-bottom: 8px;
  text-transform: uppercase;
}
.custom-group {
  margin-bottom: 16px;
}
.custom-label, .custom-text {
  font-family: Lato;
  font-size: 14px;

  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
}
.custom-label {
  font-weight: 700;
  color: #161B4D;
  margin-bottom: 10px ;
}
.custom-text {
  font-weight: 400;
}
.section-title {
  background-color: #F9FAFB;
  color: #161B4D;
  padding: 14px 21px;
  text-transform: uppercase;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.05em;
  text-align: left;
  border: 1px solid #ECECF2;
}

.section-title:first-of-type {
  border-top: none;
}
.section-body {
  padding: 14px 20px;
  .section-label, .section-value {
    font-family: Lato;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
  }
  .section-label {
    color: #161B4D;
    font-weight: 400;
  }
  .section-value {
    color: #161B4D;
    font-weight: 700;
    text-align: right;
  }

  .section-row {
    padding: 6px 0;
  }
}

.sale-item-thead {
  color: #161B4D;
  background-color: #F9FAFB;
  text-transform: uppercase;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.05em;
  text-align: left;

  tr:first-child {
    th:first-child {
      border-top-left-radius: 8px;
    }
    th:last-child {
      border-top-right-radius: 8px;
    }
  }
}
.sale-item-tbody {
  color: #161B4D;
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;

  tr {
    td {
      padding: 8px 21px;
    }
    &:first-child {
      td {
        padding-top: 16px;
      }
    }
    &:last-child {
      td {
        padding-bottom: 16px;
      }
    }
  }

}
.custom-tfoot {
  background-color: #F9FAFB;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;

  tr:last-child {
    td:first-child {
      border-bottom-left-radius: 8px;
    }
    td:last-child {
      border-bottom-right-radius: 8px;
    }
  }
}
.sales-invoice-item {
  table {
    thead,tbody, tfoot {
      font-size: 14px;
      line-height: 16px;
      letter-spacing: 0em;
      th {
        font-weight: 700;
      }
      td {
        font-weight: 400;
      }
    }

    thead, tfoot {
      background-color: #F9FAFB;
      border: 1px solid #ECECF2;
      th,td {
        padding: 12px 21px;
      }
    }
    tbody {
      tr {
        th,td {
          padding: 8px 21px;
          border: none;
        }
        &:first-child {
          th, td {
            padding-top: 16px;
          }
        }
        &:last-child {
          th, td {
            padding-bottom: 16px;
          }
        }
      }
    }
    tfoot {
      th, td {
        color: #1DA62B;
      }
    }
  }

}
::v-deep .page-content {
  background: #EEF3F7;
}
</style>